import { ValidationStrategy } from "./validation.strategy";

export class UploadValidationStrategy extends ValidationStrategy {

    public validate(): boolean {
        let isValid = false;
        let required = this.attribute.options
            .find(option => option.key.toLowerCase() == 'required' &&
                            option.value.toLowerCase() == "true");

        if(!required) {
            isValid = true;
        } else {
            isValid = this.attribute.attributes.length > 0 && 
                      this.attribute.attributes.every(attr => attr.key.length > 0)
        }

        if(!isValid) {
            //this.showError()
            return false
        }

        let minFilesOpt = this.attribute.options
            .find(option => option.key.toLowerCase() == 'minimumfiles');

        if(minFilesOpt) {
            isValid = this.attribute.attributes.length >= +minFilesOpt.value
        }

        if(!isValid) {
            //this.showError("minimumFilesError")
            return false
        }

        let maxFilesOpt = this.attribute.options
            .find(option => option.key.toLowerCase() == 'maximumfiles');

        if(maxFilesOpt) {
            isValid = this.attribute.attributes.length <= +maxFilesOpt.value
        }

        if(!isValid) {
            //this.showError("maximumFilesError")
            return false
        }

        return true
    }
}